export const ExportMessages: any = {
    TITLE: 'Exportar encuestas',
    MESSAGE_OK: 'Los datos fueron descargados exitosamente',
    MESSAGE_ERROR: 'Se presentó un error al descargar los datos',
};
